import React from 'react';
import {Routes, useLocation, useNavigationType} from 'react-router-dom';
import {AnimatePresence, motion} from 'framer-motion';

let paths = [];
let prevPath = "";

const AnimatedSwitch = ({children}) => {
    const location = useLocation();
    const navigationType = useNavigationType();
    // const isPop = navigationType == 'POP';
    const isPop = true;

    const handleAnimationEnd = () => {
        document.querySelectorAll('.animated-switch').forEach(item => {
            item.classList.add('end');
        })
    };

    const handleAnimationStart = () => {
        document.querySelectorAll('.animated-switch').forEach(item => {
            item.classList.remove('end');
        })
    };

    return (
        <AnimatePresence mode={'popLayout'} onExitComplete={() => window.scrollTo(0, 0)} initial={false}>
            <motion.div
                className={'animated-switch'}
                style={{height: "100%", width: "100%"}}
                key={location.pathname}
                initial={{opacity: 1, x: (isPop ? '100%' : '100%')}}
                animate={{opacity: 1, x: '0%'}}
                exit={{opacity: 0, x: (isPop ? '-100%' : '-100%')}}
                transition={{duration: 0.3, when: 'afterChildren'}}
                onAnimationStart={handleAnimationStart}
                onAnimationComplete={handleAnimationEnd}
            >
                <Routes location={location}>{children}</Routes>
            </motion.div>
        </AnimatePresence>
    );
};

export default AnimatedSwitch;
